export default __webpack_public_path__ + "static/media/Antillian Boots.26df2074.jpg";